const state = {
    contact: {}
}

const mutations = {
    SET_CONTACT(state, contact){
        state.contact = contact; 
    },
    SET_ACCESS_GROUPS(state, accessGroups) {
        state.contact.access_groups = accessGroups;
    },
    SET_CONTACT_AVATAR(state, image){
        state.contact.avatar = image;
    }
}

const actions = {
    initContactEdit({commit, rootGetters }, id){
        let contact = Object.assign({}, rootGetters.getContactById(id));
        commit('SET_CONTACT', contact);
    },
    updateEditContact({commit}, contact) {
        commit('SET_CONTACT', contact);
    },
    updateAccessGroups({commit, rootGetters}, accessGroupIds){
        let accessGroups = rootGetters.getAccessGroups;
        accessGroups = accessGroups.filter(a => accessGroupIds.includes(a.id));

        commit('SET_ACCESS_GROUPS', accessGroups);
    },
    clearContactEdit({commit}){
        commit('SET_CONTACT', {});
    },
    async uploadContactAvatar({commit, state, dispatch}, image){
        let payload = { refId : state.contact.id, field: 'avatar', ref: 'contact', image: image };
        let response = await dispatch('uploadImageWithRef', payload,  { root:true });
        commit('SET_CONTACT_AVATAR', response);

        return response;
    },
    async publishEditContact({ dispatch, getters }){
        const contact = getters.getContact;
        if(!contact?.id)
            return;

        await dispatch('updateContact', contact, {root: true});
    }
}

const getters = {
    getContact(state) {
        return state.contact;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}